<div class="facility-card-container">
  <div class="facility-card" [class.oge]="(isUserCo2Customer$ | async) === false">
    <div class="facility_name">
      <span class="name"> {{ facility.facility_name }}</span>
    </div>
    <div class="facility_address">
      <div class="color-copy"> {{ facility.facility_street }} {{ facility.facility_street_number }}</div>
      <div class="color-copy"> {{ facility.facility_zip_code }} {{ facility.facility_city }}</div>
    </div>
    <div *ngIf="(isUserCo2Customer$ | async) === false" class="facility_company_name">
      <div class="color-copy"> {{ facility.facility_company_name }}</div>
    </div>
    <ng-container *ngIf="isUserCo2Customer$ | async; else ogeCo2">
      <div class="facility_first_year_of_transport_capability center">
        <div class="color-copy"> {{ facility.facility_first_year_of_transport_capability }}</div>
      </div>
      <div class="facility_facilty_type center">
        <app-facility-type-badge [isCo2]="isAppViewCo2$ | async" [typeId]="facility.facility_type_id"></app-facility-type-badge>
      </div>
    </ng-container>
    <ng-template #ogeCo2>
      <div class="facility_facilty_type center">
        <app-facility-type-badge [isCo2]="isAppViewCo2$ | async" [typeId]="facility.facility_type_id"></app-facility-type-badge>
      </div>
      <div class="facility_first_year_of_transport_capability center">
        <div class="color-copy"> {{ facility.facility_first_year_of_transport_capability }}</div>
      </div>
    </ng-template>
    <div class="facility_dangling right">
      <button (click)="openDanglingWindow(facility.facility_id)"
              *ngIf="facility.facility_is_dangling && (isUserCo2Customer$ | async)"
              class="button-gotham"
              color="primary"
              mat-flat-button>
        {{ 'facility-tile.actions.facility_reassign'| translate }}
        <mat-icon iconPositionEnd>arrow_forward</mat-icon>
      </button>
    </div>

    <div class="facility_facility_first_year_of_transport_capability">
      <div class="actions">
        <button [matMenuTriggerFor]="menu" class="more-icon" mat-icon-button>
          <mat-icon fontIcon="more_horiz"></mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="onShowInformation(facility)" mat-menu-item>{{ 'facility-tile.show_info' | translate }}</button>
          <button (click)="onDeleteFacility(facility)"
                  *ngIf="(isUserCo2Customer$ | async) ||
                  (isUserOGE$ | async)" mat-menu-item>{{ 'data_table.actions.delete_facility'| translate }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

</div>
